export default __webpack_public_path__ + "static/media/QR.f4e6d99b.svg";